import { apiFetch } from './client';
import type { HROverview, HRInsightFeed, HRFlagReport, TeamBoardResponse } from '$lib/types';
import type { HRInsightRangeKey } from './hr';

export const fieldApi = {
  overview: (date?: string) => apiFetch<HROverview>(date ? `/field/overview?date=${date}` : '/field/overview'),
  insights: (range: HRInsightRangeKey) => apiFetch<HRInsightFeed>(`/field/insights?range=${range}`),
  flags: (range: HRInsightRangeKey) => apiFetch<HRFlagReport>(`/field/flags?range=${range}`),
  board: () => apiFetch<TeamBoardResponse>('/field/board')
};
